import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { CdkPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import { take } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  IResultsConversational,
  IWeightAverage,
} from 'src/app/interfaces/iresults-conversational';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ResultsConversationalService } from 'src/app/services/learner/results-conversational.service';
import { IObjectiveConversational } from 'src/app/interfaces/iobjective-conversational';
import { AppConstants } from 'src/app/app-constants';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { AccountFeatureService } from 'src/app/services/account-feature/account-feature.service';
import {
  AccuracyFeedbackState,
  IAccuracyClaim,
} from 'src/app/interfaces/iaccuracy-feedback';
import { IScoreOverallConversational } from 'src/app/interfaces/iscore-overall-conversational';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { ResponseTimeService } from 'src/app/services/general/response-time.service';
import { IScoreMessageAdherence } from 'src/app/interfaces/iscore-message-adherence';
import { IPracticeCallResult } from 'src/app/interfaces/ipractice-call-result';
import { AssignmentService } from 'src/app/services/learner/assignment.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import {
  ScoreArrayItem,
  ScoreKey,
  PromptTypesKeyMapping,
  ScoreKind,
  PracticeType,
  ResultHeaderDynamicText,
} from 'src/app/utils/enums/result/resultConversational.enum';
import { QaiDialogComponent, QaiTabsComponent } from '@qai/ui';
import { SplitIoService } from 'src/app/services/external-tools/split-io.service';
import { ICallDetailModal } from 'src/app/interfaces/icall-detail-modal';
import { IAssignmentModule } from 'src/app/interfaces/iassignment-module';
import { CallDetailsModalComponent } from '../../assignment/call-details-modal/call-details-modal.component';
import { IAssignmentModuleCall } from 'src/app/interfaces/iassignment-module-call';
import { LocaleService } from 'src/app/services/locale.service';
import { GenderService } from 'src/app/services/general/gender.service';
import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { CallFlagService } from 'src/app/services/learner/call-flag/call-flag.service';
import { HotjarService } from 'src/app/services/external-tools/hotjar.service';
import { IScoreMessageAdherenceV2 } from 'src/app/interfaces/iscore-message-adherence-v2';
import { IFlattenedMessageAdherenceSection } from 'src/app/interfaces/iflattenedMessageAdherenceSection';
import { MatSelectChange } from '@angular/material/select';
import { TranslationService } from 'src/app/services/translation.service';
import { TRANSLOCO_SCOPE, TranslocoService } from '@jsverse/transloco';
import { IComplianceScoring } from 'src/app/interfaces/icompliance-scoring';
import { getAccountNameByUuid } from 'src/app/utils/local-storage.util';
import { CallStoreService } from 'src/app/pages/learner/call/library/call-store/call-store.service';
import {
  IPersonalizedLaunchPayload,
  ICustomizationSelectionPayload,
} from 'src/app/interfaces/personalized-practice/ipersonalized-launch';
import { PathwayStepType } from 'src/app/utils/enums/learner/pathway.enum';
import { NativeCallService } from 'src/app/services/native-call.service';
import { isComplianceOnly, showsFeedbackWhenOutOfCompliance } from 'src/app/utils/constants/self-serve/compliance-score-impact.constants';

@Component({
  selector: 'app-results-conversational-new',
  standalone: false,
  templateUrl: './results-conversational-new.component.html',
  styleUrls: ['./results-conversational-new.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'results',
    },
  ],
  host: { '[class.embedded]': 'embedded' },
})
export class ResultsConversationalComponentNew implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger) tooltipMenu!: MatMenuTrigger;
  @ViewChild('modalObjectivesTemplate')
  modalObjectivesTemplate!: TemplateRef<any>;

  @ViewChild('tabs') tabs: QaiTabsComponent | undefined;
  @ViewChild('dialog') qaiDialogRef: QaiDialogComponent | undefined;
  @Input() embedded = false;

  resultReady: boolean = false;
  private pollingInterval: NodeJS.Timeout = setTimeout(() => { }, 0);
  msDuration: number = 90 * 1000;
  startTime: number = 0;
  practiceScore: number = 2;
  criteriaScore: number = 4;
  remainingAttempts: number = 3;
  isMaxAttemptsReached: boolean = false;
  dueDate: string = '14-02-25';
  weightAverage: IWeightAverage | undefined = undefined;
  displayOneSectionCard: boolean = false;

  // Conversational Results hang tight message
  isErrorLoadingScreen: boolean = false;
  displayButtonLoadingScreen: boolean = true;
  titleLoadingScreen: string = '';
  messageLoadingScreen: string = '';
  conversationalResults: IResultsConversational | undefined = undefined;
  scoreOverall: IScoreOverallConversational | undefined = undefined;
  scoreMessageAdherence: IScoreMessageAdherence[] = [];
  objectives: IObjectiveConversational[] | undefined = undefined;
  isFetchingScoreOverall: boolean = false;
  showSkillResults: boolean = false;
  isMessageAdherenceV2PromptType: boolean = false;
  flattenedSections: IFlattenedMessageAdherenceSection[] = [];
  showMissedFacts: boolean | undefined = false;

  isTooltipOpen: boolean = false;
  currentTab: string = 'callResults';

  promptTypeOverall: string = AppConstants.SCORE_OVERALL_PROMPT_TYPE;
  promptTypeCustomized: string = AppConstants.SCORE_CUSTOMIZED_PROMPT_TYPE;
  promptTypeSkills: string = AppConstants.SCORE_SKILLS_PROMPT_TYPE;
  promptTypeMessageAdherence: string =
    AppConstants.SCORE_MESSEGE_ADHERENCE_PROMPT_TYPE;
  promptTypeMessageAdherenceV2: string =
    AppConstants.SCORE_MESSAGE_ADHERENCE_V2_PROMPT_TYPE;
  promptTypeCleanTranscript: string =
    AppConstants.CLEAN_TRANSCRIPT_PROMPT_TYPE;
  typePractice: string = AppConstants.TYPE_PRACTICE;
  typeCertification: string = AppConstants.TYPE_CERTIFICATION;
  promptCompliance: string = AppConstants.SCORE_COMPLIANCE;
  practiceType: string = '';
  stepType: string | null = null;
  isPathwayFlow: boolean = false;
  enrollmentUuid: string = '';
  enrollmentStepUuid: string = '';
  stepTitle: string = '';
  pathwayName: string = '';

  get normalizedPracticeType(): string {
    if (this.isPathwayFlow) {
      if (this.stepType === PathwayStepType.PRACTICE_CALL) return PracticeType.PRACTICE;
      if (this.stepType === PathwayStepType.CERTIFICATION_CALL) return PracticeType.CERTIFICATION;
    }
    return this.practiceType;
  }

  get isSelfAuthoring(): boolean {
    return this.conversationalResults?.simulationGenerationUuid != null;
  }

  get showMessageAdherenceTab(): boolean {
    const hasPromptType =
      this.conversationalResults?.promptTypes?.includes(PromptTypesKeyMapping.MESSAGE_ADHERENCE) ||
      this.conversationalResults?.promptTypes?.includes(PromptTypesKeyMapping.MESSAGE_ADHERENCE_V2);
    return this.isSelfAuthoring
      ? !!hasPromptType && this.weightAverage?.messageAdherence != null
      : !!hasPromptType && (this.weightAverage?.messageAdherence?.weight ?? 0) > 0;
  }

  get showMethodologyTab(): boolean {
    const hasPromptType = !!this.conversationalResults?.promptTypes?.includes(PromptTypesKeyMapping.SCORE_CUSTOMIZED);
    return this.isSelfAuthoring
      ? hasPromptType && this.weightAverage?.scoreCustomized != null
      : hasPromptType && (this.weightAverage?.scoreCustomized?.weight ?? 0) > 0;
  }

  get showSkillsTab(): boolean {
    const hasPromptType = !!this.conversationalResults?.promptTypes?.includes(PromptTypesKeyMapping.SCORE_SKILLS);
    return this.isSelfAuthoring
      ? hasPromptType && this.weightAverage?.scoreSkills != null
      : hasPromptType && (this.weightAverage?.scoreSkills?.weight ?? 0) > 0;
  }

  /** The single gate on the tab; the navigation block derives from it. */
  get showAccuracyTab(): boolean {
    return (
      this.accuracyFeedbackFlagEnabled &&
      this.showFeedback &&
      !!this.conversationalResults?.accuracyFeedbackEnabled &&
      (this.conversationalResults?.accuracyDocumentCount ?? 0) > 0
    );
  }

  /** Only flagged results get a link across from the Overall Score tab. */
  get showAccuracyNavigationBlock(): boolean {
    return (
      this.showAccuracyTab &&
      this.accuracyState === AccuracyFeedbackState.Flagged
    );
  }

  practiceCallUuid: string = '';
  realtime: boolean = false;

  transcriptTab: boolean = false;
  accuracyFeedbackFlagEnabled: boolean = false;
  accuracyState: AccuracyFeedbackState = AccuracyFeedbackState.Loading;
  accuracyClaims: IAccuracyClaim[] = [];
  /** Call the loaded claims belong to, so a new session refetches. */
  private accuracyFetchedForUuid: string = '';
  /** Resolves once the feature flag is known, so a fetch never races it. */
  private accuracyFlagResolved: Promise<void> = Promise.resolve();
  private complianceScoreImpactFlag: Promise<boolean> = Promise.resolve(false);
  /** Out of compliance with the "Include feedback" setting: the other feedback still shows. */
  feedbackWhenOutOfCompliance = false;
  /** The "Compliance only" setting: the missed guidelines say no score was given. */
  complianceOnly = false;
  private readonly featureFlagsService = inject(FeatureFlagsService);
  private readonly accountFeatureService = inject(AccountFeatureService);
  private readonly cdRef = inject(ChangeDetectorRef);
  readonly nativeCallService = inject(NativeCallService);

  transcript: string = '';
  transcriptLabel: string = 'Transcript';
  overallScoreTabLabel: string = '';
  messageAdherenceTabLabel: string = '';
  objectivesTabLabel: string = '';
  agentName: string = 'Quantified';
  userName: string = 'User';

  isFadingOut: boolean = false;
  practiceCallResults: IPracticeCallResult[] = [];
  callUuid: string = '';
  moduleAssignmentUuid: string = '';

  promptTypesKeyMapping = PromptTypesKeyMapping;
  scoresArray: ScoreArrayItem[] = [];
  assignment: IAssignmentModule | undefined;
  assignmentDaysLeft: number | null = null;
  callDetails: ICallDetailModal | null = null;
  call: IAssignmentModuleCall | undefined;
  @ViewChild('callDetailsModal', { static: true, read: CdkPortalOutlet })
  callDetailsModalPortalOutlet!: CdkPortalOutlet;
  componentPortal: ComponentPortal<CallDetailsModalComponent> | null = null;
  survey_certification_complete: string = 'certification_complete';
  survey_results_first_practice: string = 'results_first_practice';
  INFINITE_ATTEMPTS = Number.MAX_SAFE_INTEGER;

  amplitudeTrackingEventHowIsCalculated: string =
    AmplitudeTrackingEvents.RESULTS_PAGE_CLICK_HOW_CALCULATED_LINK;
  scrollStrategy: ScrollStrategy | null = null;
  isUserCompliant: boolean | null = null;
  complianceScoringResult: IComplianceScoring | undefined;
  isExpandedd = true;
  anyCorrectFact: boolean = false;
  translationLoaded: boolean = false;
  isResultPersonalizedPractice: boolean = false;
  customResultMessage: string | null = null;
  hasDanglingReferences: boolean = false;

  constructor(
    private clipboard: Clipboard,
    public dialog: MatDialog,
    private resultsConversationalService: ResultsConversationalService,
    private router: Router,
    private route: ActivatedRoute,
    private gaService: GoogleAnalyticsService,
    private responseTimeService: ResponseTimeService,
    private assignmentService: AssignmentService,
    private callFlagService: CallFlagService,
    private amplitudeService: AmplitudeService,
    private splitIoService: SplitIoService,
    private localeService: LocaleService,
    private genderService: GenderService,
    private overlay: Overlay,
    private hotjarService: HotjarService,
    private translationService: TranslationService,
    private translocoService: TranslocoService,
    private callStore: CallStoreService
  ) { }

  async ngOnInit() {
    // Check if user came from result_personalized_practice route
    const routePath = this.route.snapshot.routeConfig?.path;
    this.isResultPersonalizedPractice = routePath === 'result_personalized_practice';

    this.translationService.loadScopedTranslation('results').then(() => {
      this.titleLoadingScreen = this.translocoService.translate(
        'PROCESSING_CALL',
        {},
        'results'
      );
      this.messageLoadingScreen = `${this.translocoService.translate(
        'HANG_TIGHT',
        {},
        'results'
      )} <br> ${this.translocoService.translate(
        'VIEW_YOUR_RESULTS',
        {},
        'results'
      )}`;
      this.transcriptLabel = this.translocoService.translate('TRANSCRIPT_LABEL', {}, 'results');
      const isIos = this.nativeCallService.isNativeIos;
      this.overallScoreTabLabel = this.translocoService.translate(isIos ? 'OVERALL_SCORE_TAB' : 'OVERALL_SCORE', {}, 'results');
      this.messageAdherenceTabLabel = this.translocoService.translate(isIos ? 'MESSAGE_ADHERENCE_TAB' : 'MESSAGE_ADHERENCE', {}, 'results');
      this.objectivesTabLabel = this.translocoService.translate(isIos ? 'OBJECTIVES_TAB' : 'OBJECTIVES', {}, 'results');
      this.translationLoaded = true;
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.gaService.trackPageView(event.urlAfterRedirects);
      }
    });

    // Get query params from the URL
    const params = this.route.snapshot.queryParamMap;
    this.moduleAssignmentUuid = params.get('moduleAssignmentUuid') || '';
    this.callUuid = params.get('callUuid') || '';
    this.enrollmentUuid = params.get('enrollmentUuid') || '';
    this.enrollmentStepUuid = params.get('enrollmentStepUuid') || '';
    this.stepTitle = params.get('stepTitle') || '';
    this.pathwayName = params.get('pathwayName') || '';
    
    
    // Get data
    this.complianceScoreImpactFlag = this.featureFlagsService.isFlagEnabled(AppConstants.COMPLIANCE_SCORE_IMPACT);
    this.pollData();
    this.checkTranscriptTabFeatureFlag();
    this.accuracyFlagResolved = this.resolveAccuracyTabVisibility();
  }

  ngOnDestroy() {
    if (this.callDetailsModalPortalOutlet) {
      if (this.callDetailsModalPortalOutlet.hasAttached()) {
        this.callDetailsModalPortalOutlet.detach();
      }
      if (this.scrollStrategy) {
        this.scrollStrategy.disable();
      }
    }
    this.stopPolling();
  }

  checkPollingCompletion() {
    if (this.resultReady) {
      this.stopPolling();
    }
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }

  fetchPracticeCallResults(): void {
    if (!this.callUuid || !this.moduleAssignmentUuid) {
      console.error(
        `Call UUID [${this.callUuid}] or Module Assignment UUID [${this.moduleAssignmentUuid}] not found`
      );
      return;
    }
    this.assignmentService
      .getPracticeCallResults(this.callUuid, this.moduleAssignmentUuid)
      .subscribe({
        next: (dataResponse: IPracticeCallResult[]) => {
          this.practiceCallResults = dataResponse;
          this.practiceCallResults.forEach((result) => {
            result.attemptDate = this.localeService.formatDateTime(result.attemptDate);
          })

          if (this.conversationalResults) {
            if (!this.conversationalResults.maxAttemptsAllowed)
              this.conversationalResults.maxAttemptsAllowed =
                this.INFINITE_ATTEMPTS;
            this.remainingAttempts = this.getRemainingAtempts(
              this.conversationalResults.maxAttemptsAllowed
            );
          }

          if (!this.moduleAssignmentUuid) {
            console.error('Module Assignment UUID not found for survey ');
            return;
          }
        },
        error: (err) => {
          console.error('Error occurred in fetching practice call results: ', err);
        },
        complete: () => { },
      });
  }

  onSelectedPracticeTime(event: MatSelectChange) {
    this.resultReady = false;
    const selectedValue = event.value;
    this.practiceCallUuid = selectedValue;
    console.log('Selected practice call UUID:', this.practiceCallUuid);

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { practiceCallUuid: selectedValue },
      queryParamsHandling: 'merge'
    });

    this.pollData();
  }

  pollData() {
    this.getConversationalResults();
    this.startTime = Date.now(); // Track the start time
    this.pollingInterval = setInterval(() => {
      const elapsedTime = Date.now() - this.startTime; // Calculate the elapsed time
      // After 1 minute we display longer than expected message
      if (elapsedTime >= 1 * this.msDuration) {
        this.titleLoadingScreen = this.translocoService.translate(
          'NEED_MORE_TIME',
          {},
          'results'
        );
        this.messageLoadingScreen = `${this.translocoService.translate(
          'REFRESH_INSTRUCTION',
          {},
          'results'
        )} <br> ${this.translocoService.translate(
          'RESULTS_IN_FEW_MINUTES',
          {},
          'results'
        )}`;
        this.isErrorLoadingScreen = true;
        this.displayButtonLoadingScreen = true;
        this.stopPolling(); // Stop the interval
        console.log('Polling stopped, display error message.');
      } else {
        if (!this.resultReady) {
          this.getConversationalResults();
        }
      }
    }, 5000);
  }

  getConversationalResults() {
    if (this.practiceCallUuid === '') {
      this.practiceCallUuid =
        this.route.snapshot.queryParamMap.get('practiceCallUuid')!;
    }

    if (this.practiceCallUuid === '') {
      return;
    }

    this.isUserCompliant = null;
    this.responseTimeService
      .logResponseTime(
        this.resultsConversationalService.getResultsConversationalData(
          this.practiceCallUuid
        ),
        'getConversationalResults'
      )
      .subscribe({
        next: (res: IResultsConversational) => {
          this.conversationalResults = res;
          console.log('conversational results:', this.conversationalResults);
          if (this.conversationalResults && this.conversationalResults.moduleAssignmentUuid) {
            this.callUuid = this.conversationalResults.callUuid;
            if (this.conversationalResults?.practiceCall?.isCompliant != null) {
              this.isUserCompliant = this.conversationalResults?.practiceCall.isCompliant;
            }
            this.stopPolling();
            this.practiceType = this.conversationalResults?.practiceCall?.practiceType;
            this.isPathwayFlow = this.practiceType === AppConstants.TYPE_PATHWAY;
            if (!this.isResultPersonalizedPractice) {
              this.fetchPracticeCallResults();
            }
            if (!this.isPathwayFlow) {
              this.fetchAssignment(this.conversationalResults?.moduleAssignmentUuid);
            }

            // Track pageview event
            if (this.isResultPersonalizedPractice) {
              this.logPersonalizedPracticeAmplitudeEvent(
                AmplitudeTrackingEvents.PERSONALIZED_PRACTICE_RESULTS_PAGE_PAGEVIEW,
                true // include passing_score_set and assignment_type
              );
            } else {
              this.logAmplitudeEvent(AmplitudeTrackingEvents.RESULTS_PAGE_PAGEVIEW);
            }

            this.practiceScore = this.conversationalResults?.practiceCall?.score;
            this.stepType = this.conversationalResults?.stepType ?? null;
            const stepRequirement = this.isPathwayFlow
              ? this.conversationalResults?.stepCompletionRequirement
              : null;
            this.criteriaScore =
              stepRequirement?.conditionValue ??
              this.conversationalResults?.moduleAssignmentScoreCriteria;
            this.dueDate = this.conversationalResults.moduleAssignmentEndDate;
            this.showMissedFacts = this.conversationalResults?.showMissedFacts;
            this.weightAverage = this.conversationalResults?.weightAverage;
            this.loadCustomResultMessage();
            this.hasDanglingReferences = this.conversationalResults?.hasDanglingReferences ?? false;
            this.fetchPromptsResults();
            // Scoring is done, so the accuracy row exists alongside the
            // other analysis rows.
            this.fetchAccuracyFeedback();
          }
          this.checkPollingCompletion();
        },
        error: (error) => {
          console.error('Error:', error);
          if (error.status == 500) {
            this.checkPollingCompletion();
            this.resultReady = false;
          }
        },
      });
  }

  private loadCustomResultMessage(): void {
    this.accountFeatureService
      .getResultMessageText(AppConstants.ACCOUNT_FEATURE_CUSTOM_RESULT_MESSAGING)
      .subscribe((message) => (this.customResultMessage = message));
  }

  getRemainingAtempts(maxAttemptsAllowed: number): number {
    if (maxAttemptsAllowed === 0) return this.INFINITE_ATTEMPTS;
    const remainingAttempts = Math.max(
      0,
      maxAttemptsAllowed - (this.practiceCallResults?.length || 1)
    );
    return remainingAttempts;
  }

  areAllWeightsZero(): boolean {
    if (!this.weightAverage) return false;
    return Object.values(this.weightAverage).every(
      (entry) => entry.weight === 0
    );
  }

  private getActiveCompliancePromptType(): string {
    const types = this.conversationalResults?.promptTypes ?? [];
    if (types.includes(AppConstants.COMPLIANCE_PROSECUTOR)) {
      return AppConstants.COMPLIANCE_PROSECUTOR;
    }
    return AppConstants.SCORE_COMPLIANCE;
  }

  /** Feedback sections show for compliant calls, and out of compliance with the "Include feedback" setting. */
  get showFeedback(): boolean {
    return !!this.isUserCompliant || this.feedbackWhenOutOfCompliance;
  }

  async fetchPromptsResults() {
    const practiceCallUuid = this.practiceCallUuid;
    const complianceScoreImpact = this.conversationalResults?.complianceScoreImpact;
    const complianceScoreImpactEnabled = this.isUserCompliant === false && (await this.complianceScoreImpactFlag);
    // Another attempt was opened while the flag loaded; its own fetch takes over
    if (this.practiceCallUuid !== practiceCallUuid) {
      return;
    }
    this.feedbackWhenOutOfCompliance = showsFeedbackWhenOutOfCompliance(complianceScoreImpact, complianceScoreImpactEnabled);
    this.complianceOnly = isComplianceOnly(complianceScoreImpact, complianceScoreImpactEnabled);
    let prompts: string[] = [];
    // isUserCompliant null means it is not a compliant call
    if (this.isUserCompliant !== null) {
      prompts.push(this.getActiveCompliancePromptType());
    }
    // if user not compliant then just score over all else all prompts
    if (this.isUserCompliant === false && !this.feedbackWhenOutOfCompliance) {
      prompts.push(this.promptTypeOverall)
    } else {
      prompts = [...prompts, ...(this.conversationalResults?.promptTypes ?? [])];
    }
    prompts.forEach((prompt, index) => {
      if (prompt === this.promptTypeSkills || prompt === this.promptTypeCleanTranscript) {
        return;
      }
      const isLast = index === (prompts.length - 1);
      this.resultsConversationalService.getResultsPromptTypeData(this.practiceCallUuid, prompt)
        .subscribe((res: any) => {
          this.resultReady = true;
          if (res && res?.contentDetails) {
            switch (prompt) {
              case this.promptTypeOverall: {
                this.scoreOverall = JSON.parse(res.contentDetails);
                break;
              }
              case this.promptCompliance:
              case AppConstants.COMPLIANCE_PROSECUTOR: {
                const data = JSON.parse(res.contentDetails);
                const key = Object.keys(data)[0]; // Dynamically get the weird key
                const complianceScoring = data[key];
                this.complianceScoringResult = complianceScoring;
                this.anyCorrectFact = this.checkAnyCorrectFact(this.complianceScoringResult);
                break;
              }
              case this.promptTypeCustomized: {
                const data = JSON.parse(res.contentDetails);
                const key = Object.keys(data)[0];
                const objectives = data[key];
                this.objectives = objectives;
                break;
              }
              case this.promptTypeMessageAdherence: {
                const data = JSON.parse(res.contentDetails);
                const key = Object.keys(data)[0];
                const messageAdherence = data[key];
                this.scoreMessageAdherence = messageAdherence;
                break;
              }
              case this.promptTypeMessageAdherenceV2: {
                const data = JSON.parse(res.contentDetails);
                const key = Object.keys(data)[0];
                const messageAdherence = data[key];
                const messageAdherenceV2 = this.transformResponse(messageAdherence);
                this.isMessageAdherenceV2PromptType = true;
                console.log('messageAdherenceV2 response: ', messageAdherenceV2);
              }
            }
          }
          if (isLast) this.resultReady = true;
          this.scoresArray = this.getScoreArray();
        });
    })
    if (this.isUserCompliant === null) {
      // it is null till this stage because it was returned null in conversational result,
      // when it is null we need to display the same UI which is displayed in case of isUserCompliant returned true
      this.isUserCompliant = true;
    }
  }

  navigateToRoute() {
    // Personalized practice must relaunch with its saved customizations (ephemeral flow);
    // a plain /call navigation would run the parent call's unrendered prompt.
    if (this.isResultPersonalizedPractice && !this.isPathwayFlow) {
      this.onPersonalizedPracticePracticeAgainClick(new Event('click'));
      return;
    }

    if (this.isPathwayFlow) {
      this.router.navigate([`/call`], {
        queryParams: {
          practiceType: AppConstants.TYPE_PATHWAY,
          moduleAssignmentUuid: this.conversationalResults?.moduleAssignmentUuid,
          enrollmentUuid: this.enrollmentUuid,
          enrollmentStepUuid: this.enrollmentStepUuid,
          stepType: this.stepType,
        },
      });
      return;
    }

    this.router.navigate([`/call`], {
      queryParams: {
        moduleAssignmentUuid: this.conversationalResults?.moduleAssignmentUuid,
        callUuid: this.conversationalResults?.callUuid,
        practiceType: this.conversationalResults?.practiceCall?.practiceType,
        callType: this.conversationalResults?.callType,
      },
    });
  }

  onPersonalizedPracticePracticeAgainClick(event: Event) {
    event.preventDefault();
    this.logPersonalizedPracticeAmplitudeEvent(
      AmplitudeTrackingEvents.PERSONALIZED_PRACTICE_RESULTS_PAGE_CLICK_PRACTICE_AGAIN,
      false // don't include passing_score_set and assignment_type
    );

    if (this.hasDanglingReferences) {
      this.router.navigate([
        '/personalized-practice/details',
        this.conversationalResults?.moduleUuid,
      ]);
    } else {
      // Launch call with same customizations
      this.launchPersonalizedPracticeCall();
    }
  }

  private launchPersonalizedPracticeCall(): void {
    if (!this.conversationalResults) {
      console.error('Conversational results not available');
      return;
    }

    const moduleAssignmentUuid = this.conversationalResults.moduleAssignmentUuid;
    const callUuid = this.conversationalResults.callUuid;
    const callType = this.conversationalResults.callType;
    const practiceType = this.conversationalResults.practiceCall?.practiceType;
    const customizations = this.conversationalResults.customizations;

    if (!moduleAssignmentUuid || !callUuid || !callType || !practiceType) {
      console.error('Missing required parameters for launching personalized practice call');
      return;
    }
    const customizationSelections = this.buildCustomizationSelectionsFromResponse(customizations);

    this.launchCallWithSelections(
      moduleAssignmentUuid,
      callUuid,
      practiceType,
      callType,
      customizationSelections
    );
  }

  private buildCustomizationSelectionsFromResponse(
    customizations: any
  ): ICustomizationSelectionPayload[] {
    const selections: ICustomizationSelectionPayload[] = [];

    if (!customizations) {
      return selections;
    }

    const addSelection = (entry?: { customizationTypeUuid?: string; customizationOptionUuid?: string }) => {
      if (entry?.customizationTypeUuid && entry.customizationOptionUuid) {
        selections.push({
          customizationTypeUuid: entry.customizationTypeUuid,
          selectedCustomizationOptionUuids: [entry.customizationOptionUuid],
        });
      }
    };

    // New API structure: nested objects for each customization
    addSelection(customizations.difficulty);
    addSelection(customizations.temperament);
    addSelection(customizations.tavusPersona);

    return selections;
  }

  private launchCallWithSelections(
    moduleAssignmentUuid: string,
    callUuid: string,
    practiceType: string,
    callType: string,
    customizationSelections: ICustomizationSelectionPayload[]
  ): void {
    const payload: IPersonalizedLaunchPayload = {
      moduleAssignmentUuid,
      callUuid,
      practiceType,
      callType,
      isEphemeralFlow: true,
      customizationSelections,
    };

    this.callStore.setPersonalizedLaunchPayload(payload);
    this.persistCallFlags(callUuid, callType, this.conversationalResults?.callName || '');

    const queryParams: Record<string, string | number> = {
      moduleAssignmentUuid,
      callUuid,
      practiceType,
      callType,
    };

    this.router.navigate(['/call'], {
      queryParams,
    });
  }

  private persistCallFlags(
    callUuid: string,
    callType: string,
    callName: string
  ): void {
    const callFlag: IAssignmentModuleCall = {
      callUuid,
      callType,
      callName,
      callDescription: '',
      callThumbnail: null,
      callInstruction: null,
      callScore: null,
      callStatus: 'AVAILABLE',
      maxNumberOfAttempts: null,
      recentCallAttemptDate: null,
      numberOfPreviousAttempts: 0,
      callOrder: 0,
      numberOfQuestions: null,
      hasDetails: false,
      tavusEnabled: true,
      visualAidEnabled: false,
      pauseEnabled: true,
      language: null,
    };

    this.callFlagService.saveCallFlags([callFlag]);
  }

  closeModal() {
    this.dialog.closeAll();
  }

  toggleTooltip() {
    this.isTooltipOpen = !this.isTooltipOpen;
  }

  copyText() {
    this.clipboard.copy(this.conversationalResults!.practiceCall.uuid);
    this.tooltipMenu.openMenu();

    setTimeout(() => {
      this.tooltipMenu.closeMenu();
    }, 3000);
  }

  isPassed() {
    return this.practiceScore >= this.criteriaScore;
  }

  isPassedPromptTypes(label: string, averageScore: number) {
    if (label === 'Overall score')
      return this.practiceScore >= this.criteriaScore;
    else return averageScore >= this.criteriaScore;
  }

  getLabelForKey(key: string): string {
    const labels: Record<string, string> = {
      scoreCustomized: 'Objectives',
      messageAdherence: 'Message adherence',
      messageAdherenceV2: 'Message adherence V2',
      scoreSkills: 'Skills',
    };
    return labels[key] ?? key;
  }

  getScoreArray(): ScoreArrayItem[] {
    const overallScore = {
      key: ScoreKey.Score,
      label: 'Overall score',
      value: this.practiceScore ?? 0,
      weight: 100,
      labelKey: '',
    };

    // If AVG scoring method is used, return a single overall score item
    if (this.conversationalResults?.callScoreCalcType === 'AVG') {
      return [
        {
          kind:
            this.criteriaScore === 0
              ? ScoreKind.None
              : this.isPassedPromptTypes(overallScore.label, overallScore.value)
                ? ScoreKind.Pass
                : ScoreKind.Fail,
          label: overallScore.label,
          max: '5',
          value: overallScore.value.toString(),
          // SAFE: hardcoded internal label, used to build translation key
          labelKey: overallScore.label.toUpperCase().replace(/\s+/g, '_'),
        },
      ];
    }

    // Fix: Get actual scores and weights from conversationalResults.weightAverage
    const promptToKeyMap: Record<string, keyof IWeightAverage> = {
      SCORE_CUSTOMIZED: 'scoreCustomized',
      SCORE_SKILLS: 'scoreSkills',
      MESSAGE_ADHERENCE: 'messageAdherence',
      MESSAGE_ADHERENCE_V2: 'messageAdherence',
    };

    let weightAverage: IWeightAverage = {};

    for (const prompt of this.conversationalResults?.promptTypes ?? []) {
      const key = promptToKeyMap[prompt];
      const scoreDetails = this.conversationalResults?.weightAverage?.[key];
      if (key && scoreDetails) {
        weightAverage[key] = {
          weight: scoreDetails.weight,
          average: scoreDetails.average,
        };
      }
    }

    // Build score list
    const scores = [
      overallScore,
      ...Object.entries(weightAverage).map(([key, { weight, average }]) => ({
        key: key as ScoreKey,
        label: this.getLabelForKey(key),
        value: average,
        weight,
      })),
    ];

    const keyOrder: ScoreKey[] = [
      ScoreKey.Score,
      ScoreKey.MessageAdherence,
      ScoreKey.MessageAdherenceV2,
      ScoreKey.ScoreCustomized,
      ScoreKey.ScoreSkills,
    ];

    const keyMapping: Record<ScoreKey, PromptTypesKeyMapping> = {
      [ScoreKey.Score]: PromptTypesKeyMapping.SCORE_OVERALL,
      [ScoreKey.MessageAdherence]: PromptTypesKeyMapping.MESSAGE_ADHERENCE,
      [ScoreKey.ScoreCustomized]: PromptTypesKeyMapping.SCORE_CUSTOMIZED,
      [ScoreKey.ScoreSkills]: PromptTypesKeyMapping.SCORE_SKILLS,
      [ScoreKey.MessageAdherenceV2]: PromptTypesKeyMapping.MESSAGE_ADHERENCE_V2,
    };

    // Filter based on active prompt types
    let filteredScores = scores.filter(({ key }) => {
      // Handle override for V2
      const effectiveKey =
        this.isMessageAdherenceV2PromptType && key === ScoreKey.MessageAdherence
          ? ScoreKey.MessageAdherenceV2
          : key;

      return this.conversationalResults?.promptTypes?.includes(
        keyMapping[effectiveKey]
      );
    });

    // Hide cards with 0% weight (except Overall score); in self-authoring, weight 0 means enabled so always show
    if (!this.isSelfAuthoring) {
      filteredScores = filteredScores.filter(
        ({ label, weight }) => label === 'Overall score' || (weight ?? 0) > 0
      );
    }

    // Sort the scores based on key order
    const sortedScores = filteredScores.sort((a, b) => {
      return keyOrder.indexOf(a.key) - keyOrder.indexOf(b.key);
    });

    // Format the final result
    return sortedScores.map(({ label, value, weight }) => ({
      kind:
        this.criteriaScore === 0
          ? ScoreKind.None
          : this.isPassedPromptTypes(label, value)
            ? ScoreKind.Pass
            : ScoreKind.Fail,
      label,
      max: '5',
      value: value.toString(),
      ...(label !== 'Overall score' && {
        description: this.localeService.formatPercentage(
          weight,
          this.localeService.getDecimalPlaces(weight, 2)
        ),
      }),
      labelKey: label.toUpperCase().replace(/\s+/g, '_'),
    }));
  }

  getDynamicTextForOverallScore(): ResultHeaderDynamicText {
    const date = this.localeService.formatDate(this.dueDate);
    if (this.criteriaScore === 0) {
      const userGender = this.genderService.getUserGender();
      return {
        h1: this.translocoService.translate(
          userGender === 'female'
            ? 'GREAT_JOB_PRACTICED_FEMALE'
            : 'GREAT_JOB_PRACTICED',
          {
            count: this.practiceCallResults.length,
            times: this.practiceCallResults.length === 1
              ? this.translocoService.translate('TIME', {}, 'results')
              : this.translocoService.translate('TIMES', {}, 'results')
          },
          'results'
        ),
        h2: this.dueDate
          ? `${this.translocoService.translate('REVIEW_FEEDBACK_KEEP_PRACTICING', {}, 'results')}
            ${this.translocoService.translate('UNTIL', {}, 'results')} ${date}`
          : this.translocoService.translate('HIGH_PERFORMERS_PRACTICE', {}, 'results')
      };
    }

    const passed = this.isPassed();

    if (this.normalizedPracticeType === PracticeType.PRACTICE) {
      return passed
        ? {
          h1: this.translocoService.translate('SUCCESSFULLY_PASSED', {}, 'results'),
          h2: this.dueDate
            ? `${this.translocoService.translate(
              'REVIEW_FEEDBACK_KEEP_PRACTICING',
              {},
              'results'
            )} ${this.translocoService.translate('UNTIL', {}, 'results')} ${date} ${this.translocoService.translate('TO_IMPROVE_SCORE', {}, 'results')}`
            : this.translocoService.translate('HIGH_PERFORMERS_PRACTICE', {}, 'results'),
        }
        : {
          h1: this.translocoService.translate('DIDNT_REACH_PASSING_SCORE', {}, 'results'),
          h2: this.translocoService.translate(
            this.dueDate ? 'KEEP_PRACTICING_TO_SCORE_BEFORE' : 'KEEP_PRACTICING_TO_SCORE',
            { score: this.criteriaScore, date },
            'results'
          ),

        };
    }

    if (this.normalizedPracticeType === PracticeType.CERTIFICATION) {
      if (!passed) {
        if (
          this.conversationalResults?.maxAttemptsAllowed ===
          this.INFINITE_ATTEMPTS
        ) {
          return {
            h1: this.translocoService.translate('DIDNT_REACH_PASSING_SCORE', {}, 'results'),
            h2: '',
          };
        }
        return this.remainingAttempts > 0
          ? {
            h1: this.translocoService.translate('DIDNT_REACH_PASSING_SCORE', {}, 'results'),
            h2: `${this.translocoService.translate('YOU_HAVE', {}, 'results')} ${this.remainingAttempts} ${this.translocoService.translate('MORE_ATTEMPTS', {}, 'results')} ${this.criteriaScore} ${this.translocoService.translate('OR_HIGHER_BEFORE', {}, 'results')} ${date}. ${this.translocoService.translate(
              'REVIEW_FEEDBACK_KEEP_PRACTICING',
              {},
              'results'
            )} ${this.translocoService.translate('AND_TRY_AGAIN', {}, 'results')}`,
          }
          : {
            h1: this.translocoService.translate('DIDNT_REACH_PASSING_SCORE', {}, 'results'),
            h2: this.translocoService.translate('OUT_OF_ATTEMPTS', {}, 'results'),
          };
      }

      return {
        h1: this.translocoService.translate('SUCCESSFULLY_PASSED', {}, 'results'),
        h2: this.translocoService.translate('REVIEW_FEEDBACK_THEN_RETURN', {}, 'results'),
      };
    }

    return {
      h1: `${this.translocoService.translate('UNEXPECTED_STATE', {}, 'results')}`,
      h2: `${this.translocoService.translate('REVIEW_APP_LOGIC', {}, 'results')}`,
    };
  }

  cardClicked(label: string) {
    const tabMapping: Record<string, string> = {
      Skills: PromptTypesKeyMapping.SCORE_SKILLS,
      'Message adherence': PromptTypesKeyMapping.MESSAGE_ADHERENCE,
      Objectives: PromptTypesKeyMapping.SCORE_CUSTOMIZED,
    };

    const amplitudeEventsMapping: Record<string, string> = {
      Skills: AmplitudeTrackingEvents.RESULTS_PAGE_CLICK_SKILLS_SCORE,
      'Message adherence':
        AmplitudeTrackingEvents.RESULTS_PAGE_CLICK_MESSAGE_ADHERENCE_SCORE,
      Objectives: AmplitudeTrackingEvents.RESULTS_PAGE_CLICK_OBJECTIVES_SCORE,
    };

    this.logAmplitudeEvent(amplitudeEventsMapping[label]);
    this.tabs?.selectTabById(
      tabMapping[label] || PromptTypesKeyMapping.SCORE_OVERALL
    );
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  logAmplitudeEvent(amplitudeEventKey: string) {
    if (this.conversationalResults) {
      this.amplitudeService.trackEvent(amplitudeEventKey, {
        call_type: this.conversationalResults?.callType,
        assignment_type: this.conversationalResults?.practiceCall?.practiceType,
      });
    }
  }

  logPersonalizedPracticeAmplitudeEvent(amplitudeEventKey: string, includePassingScore: boolean = false) {
    if (this.conversationalResults) {
      // Get account name from localStorage
      const currentAccountUuid = localStorage.getItem('current_account_uuid') ?? '';
      const accountName = currentAccountUuid ? getAccountNameByUuid(currentAccountUuid) : null;

      const eventData: any = {
        product_name: this.conversationalResults.moduleName ?? 'product name',
        account_name: accountName,
        conversation_type: this.conversationalResults.callName,
        difficulty:
          this.conversationalResults?.customizations?.difficulty?.displayText ?? 'difficulty',
        temperament:
          this.conversationalResults?.customizations?.temperament?.displayText ?? 'temperament',
        score_overall: this.conversationalResults?.practiceCall?.score,
      };

      if (includePassingScore) {
        eventData.assignment_type = this.conversationalResults?.practiceCall?.practiceType;
        eventData.passing_score_set = this.conversationalResults?.moduleAssignmentScoreCriteria;
      }
      this.amplitudeService.trackEvent(amplitudeEventKey, eventData);
    }
  }

  handleOnClickHowIsCalculated(amplitudeEventKey: string) {
    if (this.qaiDialogRef) {
      this.qaiDialogRef.showModal();
      this.logAmplitudeEvent(amplitudeEventKey);
    }
  }

  get getBreadcrumbs() {
    if (this.isPathwayFlow) {
      return [
        {
          text: this.translocoService.translate('ASSIGNMENTS', {}, 'results'),
          routerLink: '/assignments',
        },
        {
          text: this.pathwayName || this.translocoService.translate('RETURN_TO_PATHWAY', {}, 'results'),
          routerLink: '/learning-pathway',
          queryParams: {
            moduleAssignmentUuid: this.conversationalResults?.moduleAssignmentUuid,
            practiceType: AppConstants.TYPE_PATHWAY,
          },
        },
      ];
    }
    return [
      {
        text: this.translocoService.translate('ASSIGNMENTS', {}, 'results'),
        routerLink: '/assignments',
      },
      {
        text: this.assignment?.moduleAssignmentName || 'Assignment',
        routerLink: '/assignment',
        queryParams: {
          moduleAssignmentUuid: this.conversationalResults?.moduleAssignmentUuid,
          practiceType: this.conversationalResults?.practiceCall?.practiceType,
        },
      },
    ];
  }

  navigateToCurrentAssignment() {
    this.router.navigate([`/assignment`], {
      queryParams: {
        moduleAssignmentUuid: this.conversationalResults?.moduleAssignmentUuid,
        practiceType: this.conversationalResults?.practiceCall?.practiceType,
      },
    });
  }

  async checkTranscriptTabFeatureFlag() {
    const treatment = await this.splitIoService.getTreatment(
      AppConstants.TRANSCRIPT_TAB
    );
    console.log('Transcript Tab Feature Treatment:    ', treatment);
    this.transcriptTab = treatment === 'on';
  }

  private async resolveAccuracyTabVisibility(): Promise<void> {
    this.accuracyFeedbackFlagEnabled =
      await this.featureFlagsService.isFlagEnabled(
        AppConstants.ACCURACY_FEEDBACK
      );
    this.cdRef.detectChanges();
  }

  private async fetchAccuracyFeedback(): Promise<void> {
    await this.accuracyFlagResolved;
    if (!this.accuracyFeedbackFlagEnabled || !this.practiceCallUuid) return;
    if (this.accuracyFetchedForUuid === this.practiceCallUuid) return;
    this.accuracyFetchedForUuid = this.practiceCallUuid;

    this.accuracyState = AccuracyFeedbackState.Loading;
    this.accuracyClaims = [];

    this.resultsConversationalService
      .getAccuracyFeedback(this.practiceCallUuid)
      .pipe(take(1))
      .subscribe({
        next: ({ state, claims }) => {
          this.accuracyClaims = claims;
          this.accuracyState = state;
          this.cdRef.detectChanges();
        },
        error: () => {
          this.accuracyClaims = [];
          this.accuracyState = AccuracyFeedbackState.Error;
          this.cdRef.detectChanges();
        },
      });
  }

  /** Overall Score navigation block -> the Accuracy tab. */
  goToAccuracyTab(): void {
    this.tabs?.selectTabById(PromptTypesKeyMapping.ACCURACY_CLAIM_VERIFICATION);
  }

  trackTranscriptView() {
    this.amplitudeService.trackEvent(
      AmplitudeTrackingEvents.TRANSCRIPT_PAGE_VIEW,
      {
        call_type: 'Convesational',
      }
    );
  }

  getButtonText() {
    if (this.normalizedPracticeType === PracticeType.CERTIFICATION) return `${this.translocoService.translate('TRY_AGAIN', {}, 'results')}`;
    else return `${this.translocoService.translate('PRACTICE_AGAIN', {}, 'results')}`;
  }

  openModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.hasBackdrop = false;
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.enterAnimationDuration = 0;
    dialogConfig.exitAnimationDuration = '300ms';

    this.dialog.open(this.modalObjectivesTemplate, dialogConfig);
  }

  fetchAssignment(moduleAssignmentUuid: string): void {
    this.assignmentService
      .findByModuleAssignmentUuid(moduleAssignmentUuid)
      .subscribe({
        next: (dataResponse: IAssignmentModule | any) => {
          console.log('Assignment fetched successfully: ', dataResponse);

          // Check if open certification complete survey
          if (this.validateCertificationAssignment(dataResponse)) {
            this.openSurvey(
              this.survey_certification_complete,
              AmplitudeTrackingEvents.SURVEY_CERTIFICATION_COMPLETE
            );
          }

          // Open survey on first practice call
          this.openSurvey(
            this.survey_results_first_practice,
            AmplitudeTrackingEvents.SURVEY_RESULTS_FIRST_PRACTICE
          );

          this.processData(dataResponse);
        },
        error: (err) => {
          console.error('Error occurred in fetching assignment: ', err);
        },
      });
  }

  processData(dataResponse: IAssignmentModule | any): void {
    this.assignment = dataResponse;

    if (this.assignment) {
      // Calculate days left for assignment due date
      if (this.assignment.moduleAssignmentDueDate) {
        const assignmentDate = new Date(
          this.assignment.moduleAssignmentDueDate
        );
        const now = new Date();
        const timeDiff = assignmentDate.getTime() - now.getTime();
        this.assignmentDaysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));

        console.log('Assignment days left: ', this.assignmentDaysLeft);
      }

      this.call = this.assignment.callsWithinModuleAssignnment.find((call) => {
        return call.callUuid === this.conversationalResults?.callUuid;
      });

      if (this.call) {
        this.isMaxAttemptsReached = this.callFlagService.isMaxAttemptsReached(
          this.call
        );
        console.log('Is max attempts reached: ', this.isMaxAttemptsReached);
      }
    }
  }

  openViewCallDetailsModal(call: IAssignmentModuleCall) {
    const moduleAssignmentUuid = this.assignment?.moduleAssignmentUuid;
    const callType = call.callType;

    if (!this.callDetailsModalPortalOutlet.hasAttached()) {
      if (this.componentPortal === null) {
        this.componentPortal = new ComponentPortal(CallDetailsModalComponent);
      }
      const attachedComponentRef =
        this.callDetailsModalPortalOutlet.attachComponentPortal(
          this.componentPortal
        );
      attachedComponentRef.instance.callDetails = this.callDetails;
      attachedComponentRef.instance.moduleAssignmentUuid = moduleAssignmentUuid;
      attachedComponentRef.instance.callType = callType;
      attachedComponentRef.instance.practiceType = this.practiceType;
      attachedComponentRef.instance.call_status = call.callStatus;
      attachedComponentRef.instance.assignment_status =
        this.getAssignmentStatus();
      attachedComponentRef.instance.assignment_type =
        this.assignment?.moduleAssignmentType;
      attachedComponentRef.instance.isMaxAttemptsReached =
        this.isMaxAttemptsReached;

      this.scrollStrategy = this.overlay.scrollStrategies.block();
      this.scrollStrategy.enable();

      attachedComponentRef.instance.closeModalEvent
        .pipe(take(1))
        .subscribe(() => {
          this.callDetailsModalPortalOutlet.detach();
          this.scrollStrategy?.disable();
        });
    }
  }

  getCallDetails(call: IAssignmentModuleCall | undefined) {
    // Sending the Event of Clicking on 'View Call Details' to Amplitude
    this.amplitudeService.trackEvent('assignmentpage_click_calldetails', {
      call_status: call?.callStatus,
      assignment_status: this.getAssignmentStatus(),
      assignment_type: this.assignment?.moduleAssignmentType,
    });

    const moduleAssignmentUuid = this.assignment?.moduleAssignmentUuid;

    if (call) {
      this.assignmentService
        .getCallDetails(call.callUuid, moduleAssignmentUuid)
        .subscribe({
          next: (res: ICallDetailModal) => {
            this.callDetails = res;
            this.openViewCallDetailsModal(call);
            console.log(
              `Response received successfully for call details: ${res}`
            );
          },
          error: (err: any) => {
            console.error('Error occurred in getting call details:  ', err);
          },
        });
    }
  }

  getAssignmentStatus(): string {
    if (this.assignment) {
      const assignmentStatusComplete =
        this.assignment.callsWithinModuleAssignnment.every(
          (call) =>
            call.callStatus === 'COMPLETE' || call.callStatus === 'CERTIFIED'
        );
      const assignmentStatusNotStarted =
        this.assignment.callsWithinModuleAssignnment.every(
          (call) => call.callStatus === 'NOT_STARTED'
        );
      const assignmentStatusOverdue =
        !assignmentStatusComplete &&
        this.assignment.moduleAssignmentDueDate &&
        this.assignmentDaysLeft !== null &&
        this.assignmentDaysLeft < 0;

      if (assignmentStatusOverdue) {
        return 'Overdue';
      } else if (assignmentStatusComplete) {
        return 'Complete';
      } else if (assignmentStatusNotStarted) {
        return 'Not Started';
      } else {
        return 'Incomplete';
      }
    }
    return 'Not Started';
  }

  validateCertificationAssignment(
    assignment: IAssignmentModule | any
  ): boolean {
    if (
      !assignment ||
      !assignment.hasOwnProperty('moduleAssignmentType') ||
      assignment.moduleAssignmentType !== 'CERTIFICATION'
    ) {
      console.log('Survey ::: Module assignment type is not certification');
      return false;
    }

    if (
      !assignment ||
      !assignment.hasOwnProperty('callsWithinModuleAssignnment') ||
      assignment.callsWithinModuleAssignnment.length === 0
    ) {
      console.error('Survey ::: No calls found for the assignment');
      return false;
    }

    const calls: IAssignmentModuleCall[] =
      assignment.callsWithinModuleAssignnment;

    const currentCallCertified = calls.some(
      (call) =>
        call.callUuid === this.callUuid && call.callStatus === 'CERTIFIED'
    );

    if (!currentCallCertified) {
      console.log('Survey ::: Current call is not certified');
      return false;
    }

    return true;
  }

  openSurvey(survey: string, eventName: string) {
    const surveyLSKey = `survey_${survey}_${this.callUuid}`;

    const surveyValue = localStorage.getItem(surveyLSKey) || '';
    if (surveyValue === 'true') {
      console.log('Survey ::: Survey already taken for this call');
      return;
    }

    const attributes = {
      moduleAssignmentUuid: this.moduleAssignmentUuid,
      callUuid: this.callUuid,
    };

    this.hotjarService.openSurveyByEvent(survey, attributes, surveyLSKey, true);

    console.log(`Survey ::: Open survey [${survey}] call: ${this.callUuid}`);
    this.amplitudeService.trackEvent(eventName, {
      moduleAssignmentUuid: this.moduleAssignmentUuid,
      callUuid: this.callUuid,
      callType: this.conversationalResults?.callType,
      practiceType: this.conversationalResults?.practiceCall?.practiceType,
      assignmentType: this.assignment?.moduleAssignmentType,
    });
  }

  transformResponse(messageAdherencesV2: IScoreMessageAdherenceV2) {
    const messageAdherenceSections = messageAdherencesV2.sections;

    this.flattenedSections = messageAdherenceSections.map((section: any) => {
      const sectionTitle = Object.keys(section)[0];
      const sectionData = section[sectionTitle];

      const positives = sectionData.facts.filter(
        (fact: any) => fact.correct === 1
      );
      const negatives = sectionData.facts.filter(
        (fact: any) => fact.correct === 0
      );

      return {
        title: sectionTitle,
        positives: positives,
        negatives: negatives,
        numIncludedCorrectly: sectionData.numIncludedCorrectly,
        totalNum: sectionData.totalNum,
      };
    });
  }

  private checkAnyCorrectFact(result: IComplianceScoring | undefined): boolean {
    return (
      !!result &&
      result.sections.some(section =>
        section.facts.some(fact => fact.correct === 1)
      )
    );
  }

  get formattedScoredAt(): string {
    if (this.conversationalResults?.practiceCall?.scoredAt) {
      return this.localeService.formatDateTime(
        this.conversationalResults.practiceCall.scoredAt
      );
    }
    return '';
  }

  get formattedCallType(): string {
    const type = this.conversationalResults?.callType;
    if (!type) return '';
    const keyMap: Record<string, string> = {
      CONVERSATIONAL: 'results.CALL_TYPE_CONVERSATIONAL',
      GUIDED: 'results.CALL_TYPE_GUIDED',
      VISUAL_AID: 'results.CALL_TYPE_VISUAL_AID',
      ROLEPLAY: 'results.CALL_TYPE_ROLEPLAY',
    };
    const key = keyMap[type];
    return key
      ? this.translocoService.translate(key)
      : type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
  }
}
